export const setLoadingState = () => {
	return { loading: true };
};

export const setFinishedLoadingState = () => {
	return {
		loading: false,
	};
};

export const shouldLoad = (loading, skip, total, dataLength) => {
	return !loading && skip <= total && skip >= dataLength;
};



// WEBPACK FOOTER //
// ./src/utils/infiniteScrollUtils.js